const colors = {
    translucentBlack: 'rgba(25, 25, 25, 0.9)',
    transparent: 'transparent',
    brand: '#00D296',
    facebook: '#3b5998',
    facebookDark: '#2d4984',
    white: '#ffffff',
    error: '#F86262',
    background: '#000000',
    topNavigation: '#191919',
    body: '#383635',
    inactive: '#939393',
    labels: '#E9EAEF',
    toast: '#F7F8FB',
    thumb: '#7448FF',
    index: '#F4C900',
    middleFinger: '#24A96E',
    ringFinger: '#3991FC',
    pinky: '#FF5A76',
    premiumPlus: '#EE7D54',
    premium: '#6559F3',
    family: '#00D296',
    labelsDark: '#666666',
    baseGray: '#585A5F',
    semidarkGrey: '#2E2F34',
    mediumdarkGrey: '#3E3F43',
    darkGrey: '#1B1C1E',
    lightGrey: '#8C919D',
    lightGreen: '#C2F3DF',
    yellow: '#F6C863',
};

const space = {
    tiny: '4px',
    small: '8px',
    sbase: '12px',
    base: '16px',
    mbase: '20px',
    medium: '24px',
    large: '32px',
    xlarge: '48px',
    giant: '56px',
    xgiant: '80px',
};

const fontSizes = {
    xxs: '0.75rem', // 12px
    xs: '0.875rem', // 14px
    small: '1rem', // 16px
    medium: '1.125rem', // 18px
    large: '1.25rem', // 20px
    xl: '1.5rem', // 24px
    xxl: '2rem', // 32px
    xxxl: '2.5rem', // 40px
};

const theme = {
    colors,
    space,
    fontSizes,
};

export default theme;

export type ThemeType = typeof theme;
export type ColorVariants = keyof typeof colors;
export type SpaceVariants = keyof typeof space;
